import { Code, Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

import { BaseFilter } from './base-filter.model';
import { RdsNullFilter } from './null-filter.model';

export class FilterByCodes<V extends Variable | VariableSummary = Variable> extends BaseFilter<V> {
  constructor(variable: V, public codes: Array<Code>, nullFilter?: RdsNullFilter) {
    super(variable, nullFilter);
  }
}

export function instanceOfFilterByCodes(obj: any): obj is FilterByCodes<Variable | VariableSummary> {
  return !!obj && 'variable' in obj && 'codes' in obj;
}
